import React from "react";
import { Link } from "react-router-dom";
import { AlertCircle, Clock, Sparkles } from "lucide-react";

// Returns: { daysLeft, status: "expired" | "critical" | "warning" | "safe", message }
export const getExpiryStatus = (expiresAt, tier) => {
  if (!expiresAt) return { daysLeft: null, status: "safe" };
  const now = new Date();
  const exp = new Date(expiresAt);
  const ms = exp - now;
  const days = ms / (1000 * 60 * 60 * 24);
  const daysLeft = Math.ceil(days);
  let status = "safe";
  if (days < 0) status = "expired";
  else if (days < 1) status = "critical";
  else if ((tier === "free" && days < 3) || days < 7) status = "warning";
  return { daysLeft, status };
};

const ExpiryBanner = ({ event }) => {
  const { daysLeft, status } = getExpiryStatus(event.expires_at, event.tier);

  if (status === "safe") return null;

  const styles = {
    expired: "bg-red-50 border-red-200 text-red-800",
    critical: "bg-red-50 border-red-200 text-red-800",
    warning: "bg-amber-50 border-amber-200 text-amber-800",
  }[status];

  const Icon = status === "warning" ? Clock : AlertCircle;

  let title = "";
  let body = "";
  if (status === "expired") {
    title = "Your gallery has expired";
    body = "Guests can no longer upload. Upgrade to reactivate and extend your gallery.";
  } else if (status === "critical") {
    title = "Less than 24 hours left";
    body = "Your free gallery is about to expire. Upgrade now to keep collecting memories.";
  } else {
    const dayWord = daysLeft === 1 ? "day" : "days";
    title = `${daysLeft} ${dayWord} left on your ${event.tier === "free" ? "free demo" : "current plan"}`;
    body = event.tier === "free"
      ? "Upgrade to extend your gallery and unlock more uploads."
      : "Renew or upgrade to avoid interruption when your gallery expires.";
  }

  return (
    <div className={`border rounded-2xl px-5 py-4 flex flex-wrap items-center justify-between gap-4 ${styles} mb-6`}>
      <div className="flex items-start gap-3 flex-1 min-w-0">
        <Icon className="w-5 h-5 mt-0.5 shrink-0" />
        <div className="min-w-0">
          <div className="font-semibold">{title}</div>
          <div className="text-sm opacity-90 mt-0.5">{body}</div>
        </div>
      </div>
      <Link
        to={`/dashboard/events/${event.id}/upgrade`}
        className="bg-coral-300 text-white px-5 py-2.5 rounded-full font-semibold text-sm hover:bg-coral-400 inline-flex items-center gap-2 shrink-0"
      >
        <Sparkles className="w-4 h-4" /> Upgrade now
      </Link>
    </div>
  );
};

export default ExpiryBanner;
